import React from 'react'
import { Input, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField, ArrayItemCard, RemoveButton } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const BenefitsSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const opportunitiesTextPath = useFieldPath('sections.benefits.opportunitiesText')
  const opportunitiesListPath = useFieldPath('sections.benefits.opportunitiesList')
  const prerequisitesTextPath = useFieldPath('sections.benefits.prerequisitesText')
  const prerequisitesPath = useFieldPath('sections.benefits.prerequisites')
  const instructionsTextPath = useFieldPath('sections.benefits.instructionsText')
  const instructionsPath = useFieldPath('sections.benefits.instructions')

  const opportunitiesList = get(values, opportunitiesListPath, [])
  const prerequisites = get(values, prerequisitesPath, [])
  const instructions = get(values, instructionsPath, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      {/* Opportunities */}
      <FormField>
        <label>Texto de Oportunidades</label>
        <TextArea
          name={opportunitiesTextPath}
          value={get(values, opportunitiesTextPath, '')}
          onChange={handleChange}
          rows={3}
          placeholder="Texto introdutório sobre oportunidades"
        />
      </FormField>

      <h4>Lista de Oportunidades</h4>
      <FieldArray name={opportunitiesListPath}>
        {(arrayHelpers) => (
          <>
            {opportunitiesList.map((item, index) => (
              <div key={index} style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
                <Input
                  name={`${opportunitiesListPath}.${index}`}
                  value={item}
                  onChange={handleChange}
                  placeholder="Ex: Transporte Urbano de Passageiros"
                />
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => arrayHelpers.remove(index)}
                />
              </div>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push('')}
              block
              icon={<PlusOutlined />}
              style={{ marginBottom: 16 }}
            >
              Adicionar Oportunidade
            </Button>
          </>
        )}
      </FieldArray>

      {/* Prerequisites */}
      <FormField>
        <label>Texto de Pré-requisitos</label>
        <TextArea
          name={prerequisitesTextPath}
          value={get(values, prerequisitesTextPath, '')}
          onChange={handleChange}
          rows={3}
          placeholder="Texto introdutório sobre pré-requisitos"
        />
      </FormField>

      <h4>Lista de Pré-requisitos</h4>
      <FieldArray name={prerequisitesPath}>
        {(arrayHelpers) => (
          <>
            {prerequisites.map((item, index) => (
              <div key={index} style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
                <Input
                  name={`${prerequisitesPath}.${index}`}
                  value={item}
                  onChange={handleChange}
                  placeholder="Ex: CNH Categoria D ou E"
                />
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => arrayHelpers.remove(index)}
                />
              </div>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push('')}
              block
              icon={<PlusOutlined />}
              style={{ marginBottom: 16 }}
            >
              Adicionar Pré-requisito
            </Button>
          </>
        )}
      </FieldArray>

      {/* Instructions */}
      <FormField>
        <label>Texto de Instruções</label>
        <TextArea
          name={instructionsTextPath}
          value={get(values, instructionsTextPath, '')}
          onChange={handleChange}
          rows={3}
          placeholder="Texto introdutório sobre como fazer o curso"
        />
      </FormField>

      <h4>Lista de Instruções</h4>
      <FieldArray name={instructionsPath}>
        {(arrayHelpers) => (
          <>
            {instructions.map((item, index) => (
              <div key={index} style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
                <Input
                  name={`${instructionsPath}.${index}`}
                  value={item}
                  onChange={handleChange}
                  placeholder="Ex: Cadastre-se na plataforma e inicie o curso"
                />
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => arrayHelpers.remove(index)}
                />
              </div>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push('')}
              block
              icon={<PlusOutlined />}
            >
              Adicionar Instrução
            </Button>
          </>
        )}
      </FieldArray>
    </Card>
  )
}
